import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import { useQuery } from "@tanstack/react-query";
// import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_all, fetch_one } from "../../../lib/v31lib";
// import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../lib/practice';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

// @ts-ignore
import HeroImg from "../../../img/newest_additions/cadeau_hero.jpeg";
// @ts-ignore
import {ReactComponent as Arrow} from "../../../img/Argenco_pijl_eco_rgb.svg";

import {
  Box,
  Grid,
  List,
  ListItem,
} from '@mui/material';

import {
  Disclaimer,
  Footer,
  Hero,
  Section,
  WhiteSection,
} from '../../../components/v2/custom';
import {
  DarkGreenButton,
  Page,
  Typography
} from '../../../components/v2/styled';

// import { NewsItem as NI } from '../../models/NewsItem';
// import { User, loginFields } from '../../models/User';

// const { DateTime } = require("luxon");
// var he = require('he');

type Props = {}

export const GiftVouchers2026: FunctionComponent<Props> = ({}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);









  

  const greenBox = (num:number, title:string, text:string) => {
    return <Box
      sx={{
        backgroundColor: theme.palette.primary.light,
        borderRadius: '10px',
        padding: 4,
        width: '100%',
        height: '100%',
        position: 'relative'
      }}
    >
      <Typography variant="h3" sx={{
        fontSize: '78px',
        lineHeight: 'normal',
        marginBottom: 4
      }}>{num}</Typography>
      <Typography variant="h3" sx={{marginBottom: 4}}>{title}</Typography>
      <Typography variant="body1" sx={{color: theme.palette.primary.dark}}>{text}</Typography>
    </Box>;
  }
  const liArrow = () => {
    return <Box sx={{
      "& svg": {
        transform: "rotate(90deg)",
        width: '24px',
        marginBottom: -1
      },
      marginRight: 2.5
    }}><Arrow /></Box>
  }
  const numCircle = (num:number) => {
    return <Box
      sx={{
        backgroundColor: theme.palette.primary.light,
        borderRadius: '40px',
        padding: 1,
        minWidth: '32px',
        maxWidth: '32px',
        height: '32px',
        lineHeight: '16px',
        textAlign: 'center',
        color: 'white',
        marginRight: 2.5
      }}
    >
      {num}
    </Box>;
  }

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis({
      // duration: 2,
    });
    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);

  return <Page>
    <Hero
      picLeft={HeroImg}
      children={<>
        <Typography variant="h5" html fuck_p_tags>{t("nw.reclame")}</Typography>
        <Typography variant="h1" sx={{marginBottom: 4, marginTop: 2}}>{t("nw.landing.cadeaubon.hero.title")}</Typography>
        <Typography variant="subtitle1" sx={{marginBottom: 4, color: theme.palette.primary.dark}}>{t("nw.landing.cadeaubon.hero.subsection")}</Typography>
        <Box>
          <DarkGreenButton
            label={t("nw.landing.cadeaubon.hero.cta.subscribe")}
            id="sub_btn"
            sx={{
              borderColor: theme.palette.primary.dark,
              "&:hover": {
                borderColor: theme.palette.primary.dark,
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.dark,
              },
              display: {
                xs: 'block',
                md: 'inline-flex'
              }
            }}
            path="/buy"
          />
          <Disclaimer isSmall isCadeau />
        </Box>
      </>}
    />

    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      }
    }}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
          <Typography variant="h2" sx={{marginTop: 8}}>{t("nw.landing.cadeaubon.boxes.title")}</Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          {greenBox(
            1,
            t("nw.landing.cadeaubon.boxes_1.title"),
            t("nw.landing.cadeaubon.boxes_1.text")
          )}
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          {greenBox(
            2,
            t("nw.landing.cadeaubon.boxes_2.title"),
            t("nw.landing.cadeaubon.boxes_2.text")
          )}
        </Grid>
        <Grid item xs={12} md={12} lg={4}>
          {greenBox(
            3,
            t("nw.landing.cadeaubon.boxes_3.title"),
            t("nw.landing.cadeaubon.boxes_3.text")
          )}
        </Grid>
      </Grid>
    </WhiteSection>

    <WhiteSection>
      <Typography variant="h2" sx={{marginBottom: 4}}>{t("nw.landing.cadeaubon.faq.title")}</Typography>
      <List sx={{
        paddingLeft: 0,
        listStyle: 'none',
        "& li": {
          paddingLeft: 0
        }
      }} component="ul">
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.cadeaubon.faq.li1")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.cadeaubon.faq.li2")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.cadeaubon.faq.li3")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.cadeaubon.faq.li4")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.cadeaubon.faq.li5")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.cadeaubon.faq.li6")}</Typography></ListItem>
      </List>
    </WhiteSection>

    <Section normalPage>
      <Disclaimer />
    </Section>
    
    <Footer normalPage />
  </Page>;
}

